// extracted by mini-css-extract-plugin
module.exports = {"root":"PageBackButton_root__2GUUx"};